/**
 * Case à cocher obligatoire du formulaire de déploiement (§3.2).
 *
 * Le libellé n'est pas écrit ici : il provient de `GET /api/settings`
 * (`confirmationText`), donc de la configuration serveur. La valeur cochée est
 * transmise à l'API, qui la trace dans le journal d'audit.
 */

import { useId } from 'react';

import { FOCUS_RING } from './ui';

/** Propriétés de la case de confirmation. */
export interface ConfirmationCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Texte fourni par le serveur. */
  text: string;
}

/** Garde-fou déclaratif exigé avant tout déploiement. */
export function ConfirmationCheckbox({ checked, onChange, text }: ConfirmationCheckboxProps) {
  const id = useId();

  return (
    <div className="rounded-md border border-amber-300 bg-amber-50 p-3 dark:border-amber-900 dark:bg-amber-950/40">
      <div className="flex items-start gap-3">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          className={`mt-0.5 h-4 w-4 shrink-0 rounded border-slate-400 text-indigo-600 ${FOCUS_RING}`}
        />
        <label htmlFor={id} className="text-sm text-amber-900 dark:text-amber-200">
          {text}
          <span className="ml-1 font-semibold" aria-hidden="true">
            *
          </span>
        </label>
      </div>
    </div>
  );
}
